import React from 'react'
import { JsonLd } from 'react-schemaorg'
import { type PodcastEpisode } from 'schema-dts'

import {
  getImageUrl,
  getModifiedDate,
  getPublishedDate,
  keywordsFromTags,
  publisherId,
  structuredTextToPlain
} from '@/utils/microdata'

type Meta = {
  firstPublishedAt?: string | null
  publishedAtTimestamp?: string | null
}

type Props = {
  data: Exclude<Queries.EpisodeQuery['datoCmsPctEpisode'], null>
  url: string
}
const MicrodataEpisode: React.FC<Props> = ({ data, url }) => {
  const { excerpt, externalName, meta, tags, seo, image, content } = data
  const datePublished = getPublishedDate(meta as Meta)
  const dateModified = getModifiedDate(
    meta as Meta & { publishedAtTimestamp?: string | null }
  )
  const keywords = keywordsFromTags(tags)
  const img = getImageUrl(seo?.image ?? image)
  const transcript = structuredTextToPlain(content)

  return (
    <JsonLd<PodcastEpisode>
      item={{
        '@context': 'https://schema.org',
        '@type': 'PodcastEpisode',
        abstract: excerpt ?? '',
        name: externalName ?? '',
        image: img,
        keywords,
        ...(transcript && { text: transcript }),
        datePublished,
        dateModified,
        url,
        publisher: publisherId
      }}
    />
  )
}

export default MicrodataEpisode
